<style scoped>
.tab {
  width: 25%;
  border-radius: 2px;
  background-color: var(--color-card);
  padding: 1em;
  margin-right: 10px;
  cursor: pointer;
}
.selectedTab {
  font-weight: bold;
  border: 1px solid var(--color-accent);
}
  div {
    /*border: 1px solid red;*/
  }
</style>

<template>
  <div>
    <div style="display: flex">
      <div @click="selectTab('Trades')" class="tab" :class='{selectedTab: isSelectedTab("Trades")}'>{{ $text.tr('СДЕЛКИ') }}</div>
      <div @click="selectTab('Assets')" class="tab" :class='{selectedTab: isSelectedTab("Assets")}'>{{ $text.tr('МОНЕТЫ') }}</div>
      <div @click="selectTab('Symbols')" class="tab" :class='{selectedTab: isSelectedTab("Symbols")}'>{{ $text.tr('ПАРЫ') }}</div>
      <div @click="selectTab('Orderbook')" class="tab" style="margin-right: 0px" :class='{selectedTab: isSelectedTab("Orderbook")}'>{{ $text.tr('СТАКАН') }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TerminalTabBar extends Vue {
  selectTab (tab: string) {
    // @ts-ignore
    this.$store.state.trade.tabBarSelectedItem = tab
    // @ts-ignore
    // console.log(this.$store.state.trade.tabBarSelectedItem)
  }

  isSelectedTab (tab: string) {
    // @ts-ignore
    if (this.$store.state.trade.tabBarSelectedItem === tab) {
      return true
    }
    return false
  }
}
</script>
